import { render, staticRenderFns } from "./TrialCancellationContainer.vue?vue&type=template&id=611bf7a6&scoped=true&"
import script from "./TrialCancellationContainer.vue?vue&type=script&lang=ts&"
export * from "./TrialCancellationContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TrialCancellationContainer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TrialCancellationContainer.vue?vue&type=style&index=1&id=611bf7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611bf7a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('611bf7a6', component.options)
    } else {
      api.reload('611bf7a6', component.options)
    }
    module.hot.accept("./TrialCancellationContainer.vue?vue&type=template&id=611bf7a6&scoped=true&", function () {
      api.rerender('611bf7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/cancellation/components/TrialCancellationContainer.vue"
export default component.exports